// Linha 2 do card de condicao (spec 27/09, 1.4): "7/14" vira "7 / 14 dias".
// Texto que nao e so numeros separados por barra (ou "a vista") volta null e
// a tela mostra so o que ela digitou -- inventar leitura seria pior.
export function condicaoPorExtenso(descricao: string): string | null {
  const t = descricao.trim()
  if (t === '') return null
  const simples = t.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
  if (/^a\s*vista$/.test(simples)) return 'À vista'
  const semSufixo = simples.replace(/\s*(dias|dia|dd|d)$/, '').trim()
  if (!/^\d+(\s*\/\s*\d+)*$/.test(semSufixo)) return null
  const dias = semSufixo.split('/').map((d) => String(Number(d.trim())))
  if (dias.length === 1) return dias[0] === '1' ? '1 dia' : `${dias[0]} dias`
  return `${dias.join(' / ')} dias`
}

// Ordem de exibicao dos prazos (pedido dela, 28/09): Antecipado, A vista, e
// depois do menor para o maior. So a TELA ordena -- a `ordem` gravada nao muda.
// Texto que nao e prazo reconhecivel vai para o fim, na ordem em que veio.
function chaveDoPrazo(descricao: string): number[] {
  const simples = descricao.trim().normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
  if (/^antecipad/.test(simples)) return [0]
  if (/^a\s*vista$/.test(simples)) return [1]
  const semSufixo = simples.replace(/\s*(dias|dia|dd|d)$/, '').trim()
  if (!/^\d+(\s*\/\s*\d+)*$/.test(semSufixo)) return [3]
  return [2, ...semSufixo.split('/').map((d) => Number(d.trim()))]
}

export function ordenarPorPrazo<T>(itens: readonly T[], descricaoDe: (item: T) => string): T[] {
  const comparar = (a: number[], b: number[]) => {
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
      const x = a[i] ?? -1
      const y = b[i] ?? -1
      if (x !== y) return x - y
    }
    return 0
  }
  return itens
    .map((item, i) => ({ item, i, chave: chaveDoPrazo(descricaoDe(item)) }))
    .sort((a, b) => comparar(a.chave, b.chave) || a.i - b.i)
    .map((x) => x.item)
}
